import React from "react";
import { kotData } from "./data/kotData";

const KOT = () => {
    return (
        <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
            <div className="row g-3">
                <div className="col-sm-12">
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                        <h3 className="fw-bold mb-0">KOT</h3>
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="row g-2 list-unstyled li_animate row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-1 row-deck mb-lg-5 mb-4">
                        {kotData.map((data, index) => {
                            return (
                                <li className="col" key={index}>
                                    <div className="card room-cards p-3 h-100">
                                        <div className="d-flex align-items-center gap-2">
                                            <img src={data.room_type_icon} className="room-type-icon" alt="room_type_icon" />
                                            <div className="d-flex flex-column">
                                                <span className="kot-card-id m-0">{data.kot_id}</span>
                                                <span className="kot-card-service">{data.service_type}</span>
                                            </div>
                                        </div>
                                        <h6 className="kot-card-gname mt-2">{data.guest_name}</h6>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <ul className="list-unstyled mb-0">
                                                    <li className="kot-meal-type"><span>{data.meal_types.meal_1}</span> - <span>{data.meal_types_count.meal_1}</span></li>
                                                    <li className="kot-meal-type"><span>{data.meal_types.meal_2}</span> - <span>{data.meal_types_count.meal_2}</span></li>
                                                    <li className="kot-meal-type"><span>{data.meal_types.meal_3}</span> - <span>{data.meal_types_count.meal_3}</span></li>
                                                    <li className="kot-meal-type"><span>{data.meal_types.meal_4}</span> - <span>{data.meal_types_count.meal_4}</span></li>
                                                    <li className="kot-meal-type"><span>{data.meal_types.meal_5}</span> - <span>{data.meal_types_count.meal_5}</span></li>
                                                </ul>
                                            </div>
                                            <div className="d-flex flex-column justify-content-end row-gap-1">
                                                <button className="btn kot-primary-btn">Invoice</button>
                                                <button className="btn kot-secondary-btn">KOT</button>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default KOT